export interface ApiTokenCredentials {
    token: string;
}

export interface ApiBasicCredentials {
    username: string;
    password: string;
}

/**
 * #19351: marker credentials for REVA-API endpoints that need no authentication at all (the
 * password-reset request/redeem calls — a user who forgot their password by definition has neither
 * a valid session nor their old password). {@link ApiExecutor} sends no Authorization header for
 * these, never a stale/empty JWT.
 */
export interface ApiAnonymousCredentials {
    anonymous: true;
}

/** Singleton instance to pass wherever {@link ApiAnonymousCredentials} is needed. */
export const ANONYMOUS_CREDENTIALS: ApiAnonymousCredentials = {anonymous: true};

export type ApiCredentials = ApiTokenCredentials | ApiBasicCredentials | ApiAnonymousCredentials;

export function credentialsIsToken(credentials: ApiCredentials): credentials is ApiTokenCredentials {
    return (credentials as ApiTokenCredentials).token !== undefined;
}

export function credentialsIsBasicAuth(credentials: ApiCredentials): credentials is ApiBasicCredentials {
    const basicCredentials = credentials as ApiBasicCredentials;
    return basicCredentials.username !== undefined && basicCredentials.password !== undefined;
}

export function credentialsIsAnonymous(credentials: ApiCredentials): credentials is ApiAnonymousCredentials {
    return (credentials as ApiAnonymousCredentials).anonymous === true;
}
